module.exports = __webpack_public_path__ + "static/media/groscherie.16130048.gif";